// extracted by mini-css-extract-plugin
export var attachment = "_l3-a";
export var emailContainer = "_l3-4";
export var emailContentPaddedContainer = "_l3-b";
export var emailHeader = "_l3-6";
export var emailIframe = "_l3-3";
export var emailInfoIcon = "_l3-9";
export var emailShortenedSummary = "_l3-e";
export var infoDropdown = "_l3-0";
export var infoRowBoundedContent = "_l3-d";
export var internal = "_l3-5";
export var merchant = "_l3-8";
export var messageInputContainer = "_l3-h";
export var normal = "_l3-7";
export var replyCard = "_l3-f";
export var subtleButton = "_l3-1";
export var subtleButtonIconContainer = "_l3-2";
export var toggleViewRepliesButton = "_l3-c";
export var wrappingText = "_l3-g";